import { useLocation, Navigate } from "react-router-dom";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";
import { Lock } from "@mui/icons-material";

// Vision UI Dashboard React example components
import CenteredLayout from "layouts/authentication/components/CenteredLayout";
import Footer from "examples/Footer";

// Images
import bgSignIn from "assets/images/signUpImage.png";

// Plan data (replace with your actual Stripe Payment Links)
const plans = {
  monthly: {
    name: "Plano Mensal",
    price: "R$ 834/mês",
    link: "https://buy.stripe.com/00wcN5dn05C01dueoYa3u00", // <-- REPLACE WITH YOUR LINK
  },
  semi_annual: {
    name: "Plano Semestral",
    price: "R$ 667,17/mês",
    link: "https://buy.stripe.com/cNiaEX1Ei2pO2hy3Kka3u01", // <-- REPLACE WITH YOUR LINK
  },
  annual: {
    name: "Plano Anual",
    price: "R$ 583,80/mês",
    link: "https://buy.stripe.com/5kQ8wP96Ke8w8FWcgQa3u02", // <-- REPLACE WITH YOUR LINK
  },
};

function Subscribe() {
  const location = useLocation();
  const email = location.state?.email;

  // If no email is passed from the signup page, redirect to signup
  if (!email) {
    return <Navigate to="/authentication/sign-up" />;
  }

  const handlePlanSelection = (plan) => {
    // Append the email to the Stripe link to pre-fill it
    const url = `${plan.link}?prefilled_email=${encodeURIComponent(email)}`;
    window.location.href = url;
  };

  return (
    <CenteredLayout
      title="Escolha seu Plano"
      description="Selecione o plano que melhor se adapta às suas necessidades."
      cardContent
    >
      <VuiBox py={3}>
        <Grid container spacing={3} justifyContent="center" alignItems="stretch">
          {Object.values(plans).map((plan) => (
            <Grid item xs={12} sm={6} md={4} key={plan.name}>
              <Card sx={{ 
                height: "100%",
                backgroundColor: "rgba(255, 255, 255, 0.05)",
                backdropFilter: "blur(10px)",
                border: "1px solid rgba(255, 255, 255, 0.1)"
              }}>
                <VuiBox display="flex" flexDirection="column" justifyContent="space-between" height="100%" p={3}>
                  <VuiBox>
                    <VuiBox textAlign="center">
                      <VuiTypography variant="h4" color="white" fontWeight="bold" mb={1}>
                        {plan.name}
                      </VuiTypography>
                      <VuiTypography variant="h5" color="info" fontWeight="medium">
                        {plan.price}
                      </VuiTypography>
                    </VuiBox>
                    <VuiBox textAlign="center" mt={2}>
                      {plan.name === "Plano Mensal" && (
                        <VuiTypography variant="caption" color="text" mt={1} display="block">
                          *Plano renovado mensalmente
                        </VuiTypography>
                      )}
                      {plan.name === "Plano Semestral" && (
                        <VuiTypography variant="caption" color="text" mt={1} display="block">
                          *Pago em uma única parcela de R$ 4.003,00 e será renovado semestralmente
                        </VuiTypography>
                      )}
                      {plan.name === "Plano Anual" && (
                        <VuiTypography variant="caption" color="text" mt={1} display="block">
                          *Pago em uma única parcela de R$ 7.005,00 e será renovado anualmente
                        </VuiTypography>
                      )}
                    </VuiBox>
                  </VuiBox>
                  <VuiBox mt={3}>
                    <VuiButton variant="gradient" color="info" fullWidth onClick={() => handlePlanSelection(plan)}>
                      Selecionar Plano
                    </VuiButton>
                    <VuiBox display="flex" alignItems="center" justifyContent="center" mt={2}>
                      <Lock sx={{ color: "white", fontSize: "16px", mr: 1 }} />
                      <VuiTypography variant="caption" color="white">
                        Pagamento seguro com Stripe
                      </VuiTypography>
                    </VuiBox>
                  </VuiBox>
                </VuiBox>
              </Card>
            </Grid>
          ))}
        </Grid>
      </VuiBox>
    </CenteredLayout>
  );
}

export default Subscribe;
